import type { TagItem } from '@octopus-do/octopus-project-core'

import type { AppState } from '@/types'
import {
  selectNodeIsDimmedByTagFilter,
  selectTagVisibility,
} from './visibility'

const TAGS_LIMIT = 20

export const getUsedTags = (state: AppState, nodeId: string): TagItem[] => {
  return state.manager.project.tags
    .filter((tag) => tag.nodes.includes(nodeId))
    .slice(0, TAGS_LIMIT)
}

/**
 * `filteredByTag` — the node owns one of the selected tags;
 * `filterIsActive` — the page-tag filter is on at all.
 *
 * Non-matching pages are no longer greyed out but removed from the artboard
 * (see `./visibility`); what is left dimmed is the ancestors of a match.
 */
export const getFilteredTagsByNodeId = (
  state: AppState,
  nodeId: string
): { filteredByTag: boolean; filterIsActive: boolean } => {
  const { filterIsActive } = selectTagVisibility(state)

  return {
    filteredByTag: !selectNodeIsDimmedByTagFilter(nodeId)(state),
    filterIsActive,
  }
}
